module.exports = __webpack_public_path__ + "img/bg_h5.7aa078d4.webp";